import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as pubsub from "pubsub-js"
import {PubsubKeyEnum} from "../../enums/pubsub-key.enum";
import {ValidationTokenErrorEnum} from "../../enums/token/validation-token-error.enum";
import {TranslateService} from "@ngx-translate/core";
import {LibEnvironmentService} from "../../services/environment/lib-environment.service";
import {SystemAuthenticationService} from "../../services/sistema-autenticacion/system-authentication.service";

@Component({
  selector: 'lib-sistema-autenticacion',
  templateUrl: './sistema-autenticacion.component.html',
  styleUrls: ['./sistema-autenticacion.component.scss']
})
export class SistemaAutenticacionComponent implements OnInit {
  @Input() token: any;
  loadingButton = false;
  errorToken: boolean = false;
  errorMessage: string = '';
  errorType: string = '';
  modalRef!: NgbModalRef;
  onSuccessPubsubEvent: any;
  errorMessages: any;
  showErrorMessage: boolean = false;
  customEventName?: string;
  customCloseEventName?: string;

  constructor(
    private translateService: TranslateService,
    public environmentService: LibEnvironmentService,
    public systemAuthenticationService: SystemAuthenticationService
  ) {
    translateService.get("tokenValidation").subscribe(messages => {
      this.errorMessage = messages;
    })
  }

  ngOnInit(): void {
    this.systemAuthenticationErrorEventSubscription();
  }

  systemAuthenticationErrorEventSubscription() {
    pubsub.subscribe(PubsubKeyEnum.systemAuthenticationErrorEvent, (message, data) => {
      this.errorToken = true;
      this.errorType = data.errorType;
      this.token = null;
      this.systemAuthenticationService.hideLoading()
      switch (data.errorType) {
        case ValidationTokenErrorEnum.TOKEN_01:
          this.errorMessage = this.errorMessages?.errors?.token01
          break
        case ValidationTokenErrorEnum.TOKEN_02:
          this.errorMessage = this.errorMessages?.errors?.token02
          break
        case ValidationTokenErrorEnum.TOKEN_03:
          this.errorMessage = this.errorMessages?.errors?.token03
          break
        case ValidationTokenErrorEnum.TOKEN_04:
          pubsub.publish(PubsubKeyEnum.systemAuthenticationLockToken);
          break
      }
    })
  }
  showError() {
    this.showErrorMessage = true
  }

  closeModal() {
    this.modalRef.close();
    const event = this.customCloseEventName ?? PubsubKeyEnum.authenticationModalClosed
    pubsub.publish(event)
    this.showErrorMessage = false
  }

  onValidateToken() {
    const event = this.customEventName ?? PubsubKeyEnum.authenticationTokenModalEvent
    pubsub.publish(event, { token: this.token, modalRef: this.modalRef });
  }

  protected readonly ValidationTokenErrorEnum = ValidationTokenErrorEnum;

  disableBtn() {
    this.showErrorMessage = false
    return (!(this.token && (this.token.length === 6 || this.token.length === 8 || this.token.length === 10)) || this.systemAuthenticationService.loading)
  }
}
